export default __webpack_public_path__ + "static/bicicletaAzul-7fc9f1e705135a04e7141ff6b08c55bd.png";